<template>
  <c-form-group :id="id"
                v-slot="{ valid, errors, required, reset, invalid, dirty }"
                :form-group-class="formGroupClass"
                :inline="inline"
                :input-wrapper-class="inputWrapperClass"

                :label="label"
                :label-class="labelClass"
                :label-invisible="labelInvisible"
                :label-right="labelRight"

                :validate-custom-messages="validateCustomMessages"
                :validate-disabled="validateDisabled"
                :validate-rules="validateRules"
                :validate-vid="validateVid"
  >
    <input-tag :value="value"
               @input="onInput"
               v-bind="$attrs"
               :placeholder="placeholder || label"
               :readonly="readOnly"
               :validate="validate"
               :addTagOnKeys="addTagOnKeys"
               :addTagOnBlur="addTagOnBlur"
               :limit="limit"
               :allowDuplicates="allowDuplicates"
               :beforeAdding="beforeAdding"
               :class="{'is-invalid': errors[0] ? true: false}"
    />
    <b-form-invalid-feedback v-if="errors[0]" style="cursor: pointer" @click="reset()">* {{ errors[0] }}</b-form-invalid-feedback>
  </c-form-group>
</template>

<script>
import formGroupMixins from "@/mixins/formGroupMixins";
import InputTag from 'vue-input-tag';

export default {
  name: "CInputTag",
  components:{
    InputTag
  },
  mixins: [
    formGroupMixins
  ],
  props: {
    value: Array,
    placeholder: {
      type: String,
      default: ""
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    validate: {
      type: String | Function | Object,
      default: ""
    },
    addTagOnKeys: {
      type: Array,
      default: function() {
        return [
          13, // Return
          188, // Comma ','
          9 // Tab
        ];
      }
    },
    addTagOnBlur: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: -1
    },
    allowDuplicates: {
      type: Boolean,
      default: false
    },
    beforeAdding: {
      type: Function
    }
  },
  data() {
    return {
      id: null
    }
  },
  methods: {
    onInput(newValue) {
      this.$emit('input', newValue);
    },
  },
  mounted() {
    this.id = 'input-tag-' + this._uid;
  }

}
</script>

<style scoped>

</style>